module.exports = __webpack_public_path__ + "static/img/you.772519f4.png";